import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, map, Observable } from 'rxjs';
import { Video, VideoDto, VideoError } from '../models';

@Injectable({
    providedIn: 'root',
})
export class HttpService {
    private httpClient = inject(HttpClient);

    getVideo(id: string): Observable<Video> {
        return this.httpClient.get<VideoDto>(`api/v1/library/videos/${id}`).pipe(
            map((data) => new Video(data)),
            catchError(() => {
                throw new VideoError(id);
            }),
        );
    }
}
